export default "__VITE_ASSET__Cc7bZQfx__"